import { getSiteCode } from "./_global";
import { RegionalPopup } from "./_modal_regional-popup";
import { UserIdentModal } from "./_modal_user-ident";

document.addEventListener('DOMContentLoaded', (event) => {
  const currentSiteCode = getSiteCode();

  const australiaRegionalPopup = new RegionalPopup({
    heading: "",
    description: "Looks like you're visiting from Australia. Would you like to visit the Australia website or continue browsing the Singapore website?",
    buttonLabel: "Select Australia",
    buttonHref: "https://www.spacefurniture.com.au/",
    dismissLabel: "Select Singapore",
    delay: 250,
    isPopupCondition: function(userCountryCode) {
      const isPopupCondition = userCountryCode === "AU" && currentSiteCode === "sg";
      return isPopupCondition;
    },
    cookieTimeInDays: 0, // session cookie
  });

  const singaporeRegionalPopup = new RegionalPopup({
    heading: "",
    description: "Looks like you're visiting from Singapore. Would you like to visit the Singapore website or continue browsing the Australia website?",
    buttonLabel: "Select Singapore",
    buttonHref: "https://www.spacefurniture.com.sg/",
    dismissLabel: "Select Australia",
    delay: 250,
    isPopupCondition: function(userCountryCode) {
      const isPopupCondition = userCountryCode === "SG" && currentSiteCode === "au";
      return isPopupCondition;
    },
    cookieTimeInDays: 0, // session cookie
  });

  const malaysiaRegionalPopup = new RegionalPopup({
    heading: "Are you shopping from Malaysia?",
    description: "Please join us in our Bangsar showroom or enquire online for Malaysian pricing and product information.",
    buttonLabel: "Contact Malaysia Showroom",
    buttonHref: "https://www.spacefurniture.com.sg/blogs/news/space-at-bangsar-malaysia",
    dismissLabel: "Browse Singapore Site",
    delay: 250,
    isPopupCondition: function(userCountryCode) {
      const isPopupCondition = userCountryCode === "MY"
                               && currentSiteCode === "sg"
                               && (!window.location.pathname.includes('pages/innerspace'));
      return isPopupCondition;
    },
    cookieTimeInDays: 0, // session cookie
  });

  async function initRegionalPopups() {
    await australiaRegionalPopup.init();
    await singaporeRegionalPopup.init();
    await malaysiaRegionalPopup.init();
  }

  // 2a. Do Regional Popup when UserIntent has been closed.
  document.addEventListener('user_ident:closed', initRegionalPopups);
  // 2b. Do Regional Popup when UserIntent has already been seen.
  document.addEventListener('user_ident:seen', initRegionalPopups);

  // 3. Do Innerspace Modal after regional
  document.addEventListener('regional-popup:close', function () {
    setTimeout(() => {
      InnerSpaceModal.init();
      InnerSpaceModal.openModal();
    }, 2000);
  });

  // When we don't have a country to show the regional popup, show the innerspace popup
  document.addEventListener('regional-popup:get-customer-location', (e) => {
    if (!['AU', 'SG', 'MY'].includes(e.detail.userCountryCode)) {
      setTimeout(() => {
        InnerSpaceModal.init();
        InnerSpaceModal.openModal();
      }, 2000);
    }
  });

  // 1. User Intent Scripts
  UserIdentModal.init();
  
  // Make UserIdentModal globally available for inline onclick handlers
  window.UserIdentModal = UserIdentModal;
});
